module.exports = __webpack_public_path__ + "img/the-weight-of-blood.5c780367.png";